'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserFlow } from '../../Entities/User/UserFlow';
import { UserFlowCollection } from '../../Collections/User/UserFlowCollection';

export class UserFlowRepository extends CoreRepository {
  public getUserFlows(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserFlows(userId, options).then((response) => {
      const collection = new UserFlowCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserFlow();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getUserFlow(flowId: number, options: object = null) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getUserFlow(flowId, options).then((response) => {
      if (!response) {
        return false;
      }

      const userFlow = new UserFlow();
      userFlow.hydrate(response);

      return userFlow;
    });
  }

  public addUserFlow(payload: object = {}) {
    return this.webAPI.addUserFlow(payload).then((response) => {
      const userFlow = new UserFlow();
      userFlow.hydrate(response);

      return userFlow;
    });
  }

  public updateUserFlow(flowId: number, payload: object = {}) {
    return this.webAPI.updateUserFlow(flowId, payload).then((response) => {
      const userFlow = new UserFlow();
      userFlow.hydrate(response);

      return userFlow;
    });
  }

  public removeUserFlow(flowId: number) {
    return this.webAPI.removeUserFlow(flowId).then((response) => {
      return response;
    });
  }

  public saveFlowBundle(flowId: number, bundle: any) {
    return this.webAPI.saveFlowBundle(flowId, bundle).then((response) => {
      const userFlow = new UserFlow();
      userFlow.hydrate(response);

      return userFlow;
    });
  }
}
